import React from "react";

function Toggle(props) {
  const {
    checked,
    disabled,
    onChange,
    offColor = "red",
    onColor = "blue"
  } = props;

  let displayStyle = checked ? onColor : offColor;
  return (
    <label style={{margin: 0}}>
      <span className={`switch-wrapper`}>
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e)}
        />
        <span className='switch' style={{ backgroundColor: displayStyle }}>
          <span className="switch-handle" />
        </span>
      </span>
    </label>
  );
}

export default Toggle;



// WEBPACK FOOTER //
// ./src/components/common/Toggle.js